import './scroll-top-button.scss';

const SCROLL_THRESHOLD = 400;

function initScrollTopButton() {
	const el = document.querySelector( '.js-scroll-top-button' );
	if ( ! el ) {
		return;
	}

	const button = el.querySelector( '.a-scrollTopButton__button' );
	if ( ! button ) {
		return;
	}

	function updateVisibility() {
		if ( window.scrollY >= SCROLL_THRESHOLD ) {
			el.classList.add( '-visible' );
			el.removeAttribute( 'inert' );
		} else {
			const active = document.activeElement;
			if ( active && el.contains( active ) && typeof active.blur === 'function' ) {
				active.blur();
			}
			el.classList.remove( '-visible' );
			el.setAttribute( 'inert', '' );
		}
	}

	function handleClick() {
		window.scrollTo( { top: 0, behavior: 'smooth' } );
	}

	button.addEventListener( 'click', handleClick );

	let ticking = false;
	window.addEventListener(
		'scroll',
		() => {
			if ( ticking ) {
				return;
			}
			requestAnimationFrame( () => {
				updateVisibility();
				ticking = false;
			} );
			ticking = true;
		},
		{ passive: true }
	);

	updateVisibility();
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initScrollTopButton );
} else {
	initScrollTopButton();
}